<template>
  <AppHeaderDropdown right no-caret>
    <template v-slot:header>
      <img src="/img/white-avatar.png" class="img-avatar" :alt="userName" />
    </template>
    <template v-if="!isLoggedin" v-slot:dropdown>
      <b-dropdown-header tag="div" class="text-center">
        <strong>ข้อมูลอื่น ๆ</strong>
      </b-dropdown-header>
      <b-dropdown-item v-on:click="login">
        <i class="fa fa-sign-out" /> เข้าสู่ระบบ
      </b-dropdown-item>
      <b-dropdown-item v-on:click="register">
        <i class="fa fa-sign-out" /> สมัครสมาชิก
      </b-dropdown-item>
      <b-dropdown-item :to="{name: 'ติดต่อเรา'}"><i class="fa fa-phone-square" /> ติดต่อเรา</b-dropdown-item>
    </template>
    <template v-else v-slot:dropdown>
      <b-dropdown-header tag="div" class="text-center">
        <strong>{{ $cookies.get('email') }}</strong>
      </b-dropdown-header>
      <b-dropdown-item :to="{name: 'แก้ไขข้อมูลบริษัท'}"><i class="fa fa-pencil" /> แก้ไขข้อมูลบริษัท</b-dropdown-item>
      <b-dropdown-item :to="{name: 'เปลี่ยนรหัสผ่าน'}"><i class="fa fa-lock" /> เปลี่ยนรหัสผ่าน</b-dropdown-item>
      <b-dropdown-item :to="{name: 'ติดต่อเรา'}"><i class="fa fa-phone-square" /> ติดต่อเรา</b-dropdown-item>
      <b-dropdown-item v-on:click="logout">
        <i class="fa fa-sign-out" /> Logout
      </b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return {
      userName: '',
      isLoggedin: false
    }
  },
  mounted () {
    this.checkLogin()
    Window.Event.$on('checkLogin', this.checkLogin)
  },
  beforeDestroy () {
    Window.Event.$off('checkLogin')
  },
  methods: {
    async logout () {
      window.analytics.track('logout', {
        email: this.$cookies.get('email')
      })
      this.$cookies.remove('email')
      this.$cookies.remove('token')
      this.$cookies.remove('companyId')
      this.$router.go()
    },
    async login () {
      this.$router.push({ name: 'เข้าสู่ระบบ' })
    },
    async register () {
      this.$router.push({ name: 'สมัครสมาชิก' })
    },
    checkLogin () {
      if (this.$cookies.isKey('token')) {
        this.isLoggedin = true
      }
    }
  }
}
</script>
